export enum ApiProjections {
  DETAILED = 'DETAILED',
}

export enum CurrentViewConstants {
  PROFILELIST = 'PROFILELIST',
  PROFILECONFIRMATION = 'PROFILECONFIRMATION',
}
